import React from 'react';
import Hdr from './shared/Hdr';
import Progress from './Progress';
import { useState, useEffect, useRef } from 'react';
import swal from 'sweetalert';
import { apiPath } from "../src/services/apiConfig";

function WhyChooseUs() {
  const user = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  const usrRole = localStorage.getItem('user-role');
  const [displayWhyChooseUs, setDisplayWhyChooseUs] = useState('none');
  const [displayUpdWhyChooseUs, setDisplayUpdWhyChooseUs] = useState('none');
  const [data, setData] = useState([]);
  const [dataStat, setDataStat] = useState();
  const [verfied, setVerfied] = useState(true);
  const [id, setID] = useState('');
  //  const [Err, SetErr] = useState([]);
  const handleSubmit = () => {
    verifyWhyChooseUs()
    if (verfied) {
      formRef.current.reset();
    }
  }
  const formRef = useRef();
  const [serial, setSerial] = useState('');
  // const [specialityDataStat, setSpecialityDataStat] = useState('')
  const [shortDesc, setShortDesc] = useState('');
  const [isloading, setIsLoading] = useState(false)
  const [updSerial, setUpdSerial] = useState()
  const [updShortDesc, setUpdShortDesc] = useState()
  const [filteredID, setFilteredId] = useState()
  const [diagDatastat, setDiagDataStat] = useState()
  const [diagData, setDiagData] = useState([])
  // const [defaultDiag, setDefaultDiag] = useState()

  let txt = "";

  useEffect(() => {
    // setDefaultDiag(option[0].value)
    getDiagnosis()
    //   FindWhyChooseUs(defaultDiag)
  }, [])

  function openWhyChooseUs() {
    setDisplayWhyChooseUs('block')
  }

  function closeWhyChooseUs() {
    formRef.current.reset();
    setDisplayWhyChooseUs('none')
  }

  function openUpdWhyChooseUs() {
    setDisplayUpdWhyChooseUs('block')
  }

  function closeUpdWhyChooseUs() {
    setDisplayUpdWhyChooseUs('none')
  }

  async function updateWhyChooseUs(id) {
    //alert(id+','+filteredID+","+updSerial+", "+updShortDesc)

    let result = await fetch(apiPath + "updateDiagWhyUs", {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "id": id,
        "srl": updSerial,
        "short_desc": updShortDesc
      })
    });
    result = await result.json();

    showSwal(result.success, result.message)
    getWhyChooseUs(filteredID)
  }

  async function deleteFacility(id, sp_id) {

    let result = await fetch(apiPath + "deleteDiagWhyUs/" + id, {
      method: 'DELETE',
      headers: {
        "Authorization": `Bearer ${token}`
      },
    });
    result = await result.json();

    showSwal(result.success, result.message)

    getWhyChooseUs(filteredID)
  }

  async function updateOperation(id) {

    let result = await fetch(apiPath + "getOneDiagWhyUs/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    setUpdSerial(result.data[0].srl);
    setUpdShortDesc(result.data[0].short_desc)
    setID(result.data[0].id)

    openUpdWhyChooseUs();
  }


  function deleteOperation(id, sp_id) {

    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          deleteFacility(id, sp_id);
        }
        else {
          swal("Your record is safe!");
        }
      });
  }


  //* LIST OF ALL WhyChooseUsS (for initial screen)*/ 

  async function getWhyChooseUs(id) {
    alert(id)
    let result = await fetch(apiPath + "getDiagWhyUs/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })

    result = await result.json();
    setDiagDataStat(result.success);
    if (result.success === true) {
      setDiagData(result.data);
    } else { setDiagData([]) }
  }

  function verifyWhyChooseUs() {
    setVerfied(true)
    addWhyChooseUs()
  }

  //*ADD A NEW WhyChooseUs*/ 
  async function addWhyChooseUs() {

    if (verfied) {
      setIsLoading(true)
      let result = await fetch(apiPath + "storeDiagWhyUs", {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "diag_id": filteredID,
          "srl": serial,
          "short_desc": shortDesc,
        })
      });
      result = await result.json();

      //      if (result.success) { }
      //      else {
      //        SetErr(result.data);
      //      }

      showSwal(result.success, result.message)

      getWhyChooseUs(filteredID)

      if (isloading) {
      } else {
        setIsLoading(false)
      }
    }
  }


  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success!",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }

  //* LIST OF ALL Diagnosis (for initial screen)*/ 

  async function getDiagnosis() {

    let result = await fetch(apiPath + "diagnostics",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })
    result = await result.json();

    setDataStat(result.success);
    setData(result.data);

    if (result.success === true) {
      setData(result.data);
    } else { setData([]) }
  }

  function FilterData(id) {

  }

  function FindWhyChooseUs(id) {
    //alert(id)
    setFilteredId(id)
    getWhyChooseUs(id)

  }

  return (

    <div style={{ 'height': '90vh' }}>
      <Hdr />
      <div className="row p16">
        <div className="c12-l-8">
          <h3 className="" >ADS Hospital - User : {user} </h3>
        </div>
        <div className="c12-l-4 pr32 ">
          <p className="medium right">User : ({usrRole})</p>
        </div>
      </div>


      <div className="row p16" style={{ 'height': '90%' }}>
        <div className=" c12-l-12 cont__content p4" style={{ 'height': '100%' }}>
          <div className="row p16">
            <div className="c12-l-3">
              <h4 className="wide">Why Choose Us</h4>
            </div>
            <div className="c12-l-5"></div>
            <div className="c12-l-2">
              <select className="custom-select" onChange={(e) => FindWhyChooseUs(e.target.value)}>
                {
                  (dataStat === true ?
                    (
                      data.map((item2, index) =>
                        <option value={item2.id}>{item2.name}</option>
                      ))
                    : <option value={0}>No Data</option>)
                }
              </select>
            </div>
            <div className="c12-l-1">
              <button onClick={openWhyChooseUs} type="button" name="button"
                className="btn solid round">Add Reasons </button>
            </div>
          </div>

          <div className="row mt16" >
          </div>

          <div className="row mt16" >
            <table style={{ 'height': '100%', 'width': '100%', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
              <thead>
                <tr>
                  <th className="th-border center" width="15%">Id</th>
                  <th className="th-border center" width="15%">Srl</th>
                  <th className="th-border left" width="7%">Icon</th>
                  <th className="th-border left" width="45%">Short Desc</th>
                  <th className="th-border left" width="15%">Edit</th>
                  <th className="th-border left" width="15%">Delete</th>
                </tr>
              </thead>
              <tbody >
                {
                  (diagDatastat === true ?
                    (
                      diagData.map((item, index) =>
                        <tr className="tr-border" key={index}>
                          <td className="center">{item.id}</td>
                          <td className="center">{item.srl}</td>
                          <td className="center"><img src={`https://adshospital.site${item.icon}`} width={25} height={25} alt=''></img></td>
                          <td className="left">{item.short_desc}</td>
                          <td onClick={() => { updateOperation(item.id) }} className="center"><img src={require('./asset/images/adm_edit.png')} alt="" /></td>
                          <td onClick={() => { deleteOperation(item.id, { filteredID }) }} className="center"><img src={require('./asset/images/adm_del.png')} alt="" /></td>
                        </tr>
                      ))
                    : <tr><td>No data</td></tr>)
                }
              </tbody>
            </table>
          </div>

          {/* SCREEN FROM ADDING NEW WhyChooseUs */}

          <div id="newdept" style={{ 'display': displayWhyChooseUs }} className="cont__new-dept">
            <form className="" action="" method="" ref={formRef}>
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeWhyChooseUs}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Add Reasons</h2>
                  <br></br>

                  <input type="hidden" value={filteredID} />

                  <input type="text" className="box small" autoComplete="off"
                    placeholder="Serial" onChange={(e) => setSerial(e.target.value)} />

                  <textarea className="box small" autoComplete="off" rows='10'
                    placeholder="Short Description" onChange={(e) => setShortDesc(e.target.value)} />

                  <br></br>
                  <button onClick={handleSubmit} type="button"
                    className="btn solid round">Add Reasons</button>

                  {
                    (isloading === true ?

                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '5px'
                      }}><Progress /></div>
                      :
                      <div></div>
                    )
                  }
                </div>
              </div>
            </form>
          </div>

          {/* SCREEN FROM UPDTAE EXISTING WhyChooseUs */}

          <div id="newdept" style={{ 'display': displayUpdWhyChooseUs }} className="cont__new-dept">
            <form className="" action="" method="">
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeUpdWhyChooseUs}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Edit Reason</h2><br /><br />

                  <input type="hidden" value={id} />
                  <input type="text" className="box small"
                    placeholder="Serial" onChange={(e) => setUpdSerial(e.target.value)}
                    value={updSerial} />

                  <input type="text" className="box small"
                    placeholder="Short Description" onChange={(e) => setUpdShortDesc(e.target.value)}
                    value={updShortDesc} />

                  <br></br>
                  <button onClick={() => { updateWhyChooseUs(id) }} type="button"
                    className="btn solid round">Update</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhyChooseUs;
